import React from 'react';
import {
  IconButton,
} from '@mui/material';


export default function SecondaryButton(props) {
  const { hoverColor, icon, onClick, color } = props

  if(color == null){
    let buttonColor = '#121212';
  }
  return (
    <IconButton
        onClick={onClick}
        sx={{
            color: color,
            '&:hover': {
                color: hoverColor
            },
            transition: 'color 0.15s ease-out',
    }}>
        {icon}
    </IconButton>
  );
}